import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function MiseEnGarde() {
  const { t } = useTranslation('blogprix');
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.1);

  return (
    <section ref={ref} id="garde" className="scroll-mt-28">
      <div className={`bg-slate-primary rounded-xl p-6 md:p-8 transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}>
        <div className="flex items-start gap-3 mb-4">
          <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-full bg-copper/20">
            <i className="ri-alert-line text-copper text-lg" />
          </div>
          <h2 className="font-manrope font-bold text-white text-lg md:text-xl">{t('garde_h2')}</h2>
        </div>

        <p className="text-white/70 text-sm md:text-base leading-relaxed mb-4">{t('garde_p1')}</p>

        <ul className="space-y-3 mb-5">
          <li className="flex gap-3">
            <span className="w-1.5 h-1.5 shrink-0 rounded-full bg-copper mt-2" />
            <p className="text-white/70 text-sm leading-relaxed">{t('garde_li_1')}</p>
          </li>
          <li className="flex gap-3">
            <span className="w-1.5 h-1.5 shrink-0 rounded-full bg-copper mt-2" />
            <p className="text-white/70 text-sm leading-relaxed">{t('garde_li_2')}</p>
          </li>
          <li className="flex gap-3">
            <span className="w-1.5 h-1.5 shrink-0 rounded-full bg-copper mt-2" />
            <p className="text-white/70 text-sm leading-relaxed">{t('garde_li_3')}</p>
          </li>
          <li className="flex gap-3">
            <span className="w-1.5 h-1.5 shrink-0 rounded-full bg-copper mt-2" />
            <p className="text-white/70 text-sm leading-relaxed">{t('garde_li_4')}</p>
          </li>
        </ul>

        <p className="text-white/70 text-sm md:text-base leading-relaxed">{t('garde_p2')}</p>
      </div>
    </section>
  );
}